import MojitoCore from 'mojito/core';

import {OPEN_EXTERNAL_URL} from '#core/utils/intent-factory.js';
import {addParamToURL} from '#core/utils/url-utils.js';
import {buildWindowFeatures} from '#core/utils/utils.js';

const reduxInstance = MojitoCore.Services.redux;
const IntentActions = MojitoCore.Intents.actions;

function handlePublishIntent(action) {
    const {payload: intent} = action;
    const data = intent.data || {};

    if (intent.type === OPEN_EXTERNAL_URL) {
        let url = data.url;
        if (!url) return true;

        if (data.addBackUrl) {
            const back_url = window.location;
            url = addParamToURL(url, 'back_url', back_url);
        }

        if (data.windowName !== undefined) {
            window.open(url, data.windowName, buildWindowFeatures(data));
        } else {
            window.location.assign(url);
        }

        return true;
    }

    return false;
}

reduxInstance.actionListener.startListening({
    actionCreator: IntentActions.publishIntent,
    effect: handlePublishIntent,
});
